const AvailabilityType = {
  Availability: 'Availability',
  Request: 'Request',
  Unavailable: 'Unavailable'
};

export default AvailabilityType;
